module.exports = __webpack_public_path__ + "img/banner2.cfe264c7.jpg";